import { useTranslation } from 'react-i18next';
import { LAYOUT_TYPE } from '../Model/Model';

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Options of the Create Layout tab, split in rows of three like the design.
 */
const CreateLayoutTabApp = ({ item, emptyFields }) => {
    const { t } = useTranslation();
    const layoutTypes = Object.values(LAYOUT_TYPE);
    const rows = [layoutTypes.slice(0, 3), layoutTypes.slice(3, 6)];
    const typeRequired = emptyFields && !item?.typeId;

    return {
        t,
        rows,
        typeRequired
    };
};

export default CreateLayoutTabApp;
